import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actionCreator from '../../store/actions/index';

import Auxilliary from '../../hoc/Auxilliary/Auxilliary';

import Burger from '../../components/Burger/Burger';
import BurgerControls from '../../components/Burger/BuildControls/BuildControls';
import Modal from '../../components/UI/Modal/Modal';
import OrderSummary from '../../components/Burger/OrderSummary/OrderSummary';
import Spinner from '../../components/UI/Spinner/Spinner';
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';
import axios from '../../axios-orders';

class BurgerBuilder extends Component {
	state = {
		orderNow: false,
	};

	componentDidMount() {
		this.props.initBurgerBuilderHandler();
	}

	updatePurchaseable(ingredients) {
		let sum = 0;
		for (let ing in ingredients) {
			sum += ingredients[ing];
		}
		return sum > 0;
	}

	getControls(ingredients) {
		const controls = [];
		for (let ing in ingredients) {
			controls.push({ type: ing });
		}
		return controls;
	}

	orderNowHandler = () => {
		if (!this.props.isAuthenticated) {
			this.props.onSetAuthRedirectPath('/checkout');
			this.props.history.push('/user/signin');
		} else {
			this.setState({
				orderNow: true,
			});
		}
	};

	cancelOrderHandler = () => {
		this.setState({
			orderNow: false,
		});
	};

	orderContinuedHandler = () => {
		this.props.onInitPurchasing();
		this.props.history.push('/checkout');
	};

	render() {
		const disabledInfo = {};
		for (let ing in this.props.ingredients) {
			disabledInfo[ing] = this.props.ingredients[ing] === 0;
		}

		let modalContent = (
			<OrderSummary
				cancelOrder={this.cancelOrderHandler}
				continueOrder={this.orderContinuedHandler}
				ingredients={this.props.ingredients}
				price={this.props.totalPrice}
			/>
		);

		let burger = this.props.error ? (
			<p style={{ textAlign: 'center' }}>Some Error has ocurred</p>
		) : (
			<Spinner />
		);

		if (this.props.ingredients) {
			burger = (
				<Auxilliary>
					<Burger ingredients={this.props.ingredients} />
					<BurgerControls
						addIngredient={this.props.addIngredientHandler}
						removeIngredient={this.props.removeIngredientHandler}
						disabledInfo={disabledInfo}
						purchaseable={this.updatePurchaseable(this.props.ingredients)}
						orderNow={this.orderNowHandler}
						isAuth={this.props.isAuthenticated}
						price={this.props.totalPrice}
						controls={this.getControls(this.props.ingredients)}
					/>
				</Auxilliary>
			);
		}

		return (
			<Auxilliary>
				<Modal closeModal={this.cancelOrderHandler} show={this.state.orderNow}>
					{modalContent}
				</Modal>
				{burger}
			</Auxilliary>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		ingredients: state.burgerBuilder.ingredients,
		totalPrice: state.burgerBuilder.totalPrice,
		error: state.burgerBuilder.error,
		isAuthenticated: state.auth.token !== null,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		addIngredientHandler: (ingredient) =>
			dispatch(actionCreator.addIngredient(ingredient)),

		removeIngredientHandler: (ingredient) =>
			dispatch(actionCreator.removeIngredient(ingredient)),

		initBurgerBuilderHandler: () => {
			dispatch(actionCreator.initIngredients());
		},
		onInitPurchasing: () => dispatch(actionCreator.purchasingInit()),
		onSetAuthRedirectPath: (path) =>
			dispatch(actionCreator.setAuthRedirectPath(path)),
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withErrorHandler(BurgerBuilder, axios));
